module.exports = __webpack_public_path__ + "static/SM5-c8b65cabb794ccbefe92648ec29d94a1.jpg";